import React from "react";
import "./App.css";
import "./Responsive.css";

import Navbar from "../src/Components/BybMainPage/BybNavbar/HeaderNavbar";
import BybBanner from "../src/Components/BybMainPage/BybBanner/BybBanner";
// import BybAudit from "./Components/JoinWhatsApp/JoinWhatsApp";
// import BybAnalysis from "./Components/BybAnalysis/ExpertsInsight";
// import BybSurveyDeck from "./Components/BybSurveydeck/BybSurveyDeck";
// import BybGuides from "./Components/BybGuides/BybGuides";
// import BybBrewingProcess from "./Components/FourDProcess/FourDProcess";
// import BybStartup from "./Components/BybStartup/BybStartup";
// import BybChooseBrand from "./Components/BybChooseyourbrew/BybChooseBrand";
import BybFooter from "../src/Components/BybMainPage/BybFooter/BybFooter";
// import BybBonusDecks from "./Components/BybBonusdecks/BybBonusDecks";
// import BybWhyBrew from "./Components/BybWhybrew/BybWhyBrew";
// import ScrollPage from "./Components/HandsOn/HandsOn";

// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import BybPrivacyPolicy from "./Components/BybPrivacyPolicy/BybPrivacyPolicy";
// import BybTermsCondition from "./Components/BybTermsCondition/BybTermsCondition";
// import BybShipDelivery from "./Components/BybShipDelivery/BybShipDelivery";
// import BybCancelRefund from "./Components/BybCancelRefund/BybCancelRefund";
// import KitImage from "./Components/KitImage/KitImage";
// import Privacy from "./Privacy";
// import ScrollThroughHero from "./Components/HandsOn/HandsOn";
import JoinWhatsApp from "../src/Components/BybMainPage/JoinWhatsApp/JoinWhatsApp";
import ExpertsInsight from "../src/Components/BybMainPage/BybAnalysis/ExpertsInsight";
import Header from "../src/Components/BybMainPage/Paral";
import FourDProcess from "../src/Components/BybMainPage/FourDProcess/FourDProcess";
import HandsOn from "../src/Components/BybMainPage/HandsOn/HandsOn";
import BrandSelf from "../src/Components/BybMainPage/BrandSelf/BrandSelf";
import FindYourSpace from "../src/Components/BybMainPage/FindYourSpace/FindYourSpace";
import PageSeo from "./Components/Common/Seo/PageSeo";
import {
  buildOrganizationSchema,
  buildWebSiteSchema,
} from "./Components/Common/Seo/seoUtils";

const Index = () => {
  return (
    <>
      {/*
        Structured data stays in the document head only, so this does not affect the visible UI.
        SearchAction is intentionally omitted here because the public site does not expose a dedicated
        search results endpoint yet.
      */}
      <PageSeo
        title="Brand-Building Resources, Community, eMagazine & Assessment Tools | Brew Your Brand"
        description="Explore Brew Your Brand's brand-building resources, founder community, eMagazine, quick brand assessment, and self-audit tools for stronger brand clarity and growth."
        canonical="/"
        ogTitle="Brand-Building Resources, Community, eMagazine & Assessment Tools | Brew Your Brand"
        ogDescription="Discover BYB's brand-building resources, assessment tools, eMagazine, and founder-focused community for clearer, stronger branding."
        ogImage="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/og_arrow.png"
        structuredData={[
          buildOrganizationSchema(),
          buildWebSiteSchema(),
        ]}
      />

      <Navbar />
      <BybBanner />
      <Header />
      <FourDProcess />
      <JoinWhatsApp />
      <ExpertsInsight />
      <HandsOn />
      <BrandSelf />
      <FindYourSpace />
      <BybFooter />
    </>
  );
};

export default Index;
